










import { Component, Vue } from 'vue-property-decorator';
import DataManage from '@/layout/slider/data-manage.vue';
import { eventBus } from '@/main';
/**
 * 框架入口文件
 */
@Component({
    components: {
        DataManage,
    },
})
export default class DataView extends Vue {
    /** */
    isRouterAlive = true;

    /**
     *获取主界面是否在加载中
     */
    get isMainOnLoading(): boolean {
        return this.$store.getters.getIsMainOnLoading;
    }
    /**
     * @author guan
     * @description
     * @return void
     */
    mounted(): void {
        eventBus.$on('reload', () => {
            this.isRouterAlive = false;
            this.$nextTick(() => (this.isRouterAlive = true));
        });
    }
}
